/**
 * @file: ComplaintAdvice.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 投诉建议管理
 */
import request from '@/utils/request'

/**
 * 新增投诉建议(不需要token)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceAdd(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/add',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-今日投诉和评价统计
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceBigdataGet(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/bigdata/get',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-投诉和评价分析全部导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceBigdataListExport(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-投诉和评价分析列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceBigdataListGet(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-投诉和评价分析部分导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceBigdataListOptionExport(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 删除投诉建议
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceDelete(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/delete',
    method: 'post',
    data
  })
}

/**
 * 获取投诉建议详情(不需要token)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceGet(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/get',
    method: 'post',
    data
  })
}

/**
 * 我的建议(分页)(不需要token)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceListGet(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/list/get',
    method: 'post',
    data
  })
}

/**
 * 投诉建议管理列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdvicePageListGet(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 回复投诉
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function complaintAdviceUpdate(data) {
  return request({
    type: 'biz',
    url: 'complaint/advice/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ComplaintAdvice.js